<mat-form-field [ngClass]="isFilter ? 'isFilter' : null" floatLabel="never">
  <input type="text" matInput [formControl]="control" [matAutocomplete]="auto"
    (keydown.space)="$event.stopPropagation()" [placeholder]="isFilter ? 'Filtre' : null">
  <mat-label *ngIf="!isFilter">{{ label | translate }}</mat-label>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
    (optionSelected)="onChange(); isFilter ? selectedOptionForFilter.emit() : null">
    <mat-option *ngFor="let item of filteredList | async" [value]="item" [title]="item.display">
      {{ item.display }}
    </mat-option>
  </mat-autocomplete>
  <mat-error>{{ errorMsg | translate }}</mat-error>
</mat-form-field>